import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApplicantDetailsComponent } from '../../../shared/components/applicant-details/applicant-details.component';
import { AddressDetailsComponent } from '../../../shared/components/address-details/address-details.component';
import { WorkrequestSrpComponent } from '../workrequest-srp/workrequest-srp.component';
import { LoginService } from '../../../shared/services/login.service';
import { SrpService } from '../srp.service';
import { Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { PlumberDetailsComponent } from '../../../shared/components/plumber-details/plumber-details.component';
import { UploadFileComponent } from '../../../shared/components/upload-file/upload-file.component';
import { PlumberDetails } from '../../../shared/data-objects/plumber-details';
import { UploadfilesViewmodel } from '../../../shared/viewmodels/uploadfiles-viewmodel';
import { Steps } from 'primeng/primeng';
import { IppaymentComponent } from '../../../shared/components/ippayment/ippayment.component';
import { IppaymentService } from '../../../shared/services/ippayment.service';
import { ApplicationFormBase } from '../../../shared/data-objects/application-form-base';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import { ServiceBase } from '../../../shared/services/service-base';
import { Srp } from '../srp';
import { ApplicationBase } from '../../../shared/data-objects/application-base';
import { WorkrequestViewmodelBase } from '../../../shared/viewmodels/workrequest-viewmodel-base';
import { Meta } from '@angular/platform-browser';
import { AddressService } from '../../../shared/services/address.service';
import { environment } from '../../../../app-environments/environment';

const referenceNumberRE = /^[a-zA-Z0-9\-\/\.\:]+$/;

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: 'app-srp',
  templateUrl: 'srp.component.html',
  styleUrls: ['srp.component.css'],
  entryComponents: [
    AddressDetailsComponent, WorkrequestSrpComponent, ApplicantDetailsComponent, PlumberDetailsComponent,
    UploadFileComponent, IppaymentComponent
  ],
  encapsulation: ViewEncapsulation.None
})

export class SrpComponent extends ApplicationFormBase<Srp> implements OnInit {
  isRequesting: boolean;
  refNumControl: FormControl;
  refNumControlLength = 11;
  imageSourceUrl = ServiceBase.baseHref + '/assets/images/siteplan.png';
  cwwPricingZone: boolean = false;
  termsOfUseUrl: string = '';

  @ViewChild('WorkrequestComponent') workrequestComponent: WorkrequestSrpComponent;
  @ViewChild('PlumberDetailsComponent') plumberDetailsComponent: PlumberDetailsComponent;

  constructor(protected loginService: LoginService, private addressService: AddressService,
    private srpService: SrpService, protected ipPaymentService: IppaymentService, protected router: Router, private meta: Meta) {
    super(srpService, loginService, ipPaymentService, router);
    this.refNumControl = new FormControl('', [Validators.maxLength(this.refNumControlLength), Validators.pattern(referenceNumberRE)]);
    this.meta.updateTag({ name: 'description', content: 'Request to carry out plumbing work for sewerage, drinking water and/or recycled water to a single residential property.' });

    this.addressService.getPricingZone().subscribe(_pricingzone => {
      console.log(_pricingzone.toUpperCase());
      this.cwwPricingZone = (_pricingzone && _pricingzone.toUpperCase() === 'FMR CWW');
      this.updatePaymentTab(this.shouldShowPaymentInfo);
    }, err => {
      this.cwwPricingZone = true;
    });
  }

  async ngOnInit() {
    let isTokenValid = await this.loginService.isTokenValid();
    if (!isTokenValid) {
      // if (this.loginService.isGuestUserLoggedIn()) {
      //   this.loginService.guestLogin((ok: boolean) => {
      //     this.setupTotalOrderAmount();
      //     this.setupTabs();
      //   });
      // } else {
        this.router.navigate(['/login']);
      // }
    } else {
      await this.loginService.refreshToken();
      this.setupTotalOrderAmount();
      this.setupTabs();
      this.updatePaymentTab(this.shouldShowPaymentInfo);
    }
  }

  setupTotalOrderAmount(): void {
    this.ipPaymentService.paymentformIsInit.subscribe((data: any) => {
      this.paymentformIsInit(6, this.workrequestComponent.totalOrderAmount);
    });
  }

  setupTabs(): void {
    const me = this;
    // if (!this.loginService.isGuestUserLoggedIn()) {
    if (this.loginService.isUserBillLater()) {
      this.setApplicantDetailsForBillLater(this.srpService.applicationData.applicant);
      this.addMenuItem('Location details', me, 0, 'First Step');
      this.addMenuItem('Work request', me, 1, 'Second Step');
      this.addMenuItem('Plumber details', me, 2, 'Third Step');
      this.addMenuItem('Upload site plan', me, 3, 'Fourth Step');
      this.addMenuItem('Applicant details', me, 4, 'Fifth Step');
      this.addMenuItem('Review and submit', me, 5, 'Sixth Step');
    } else {
      // this.setApplicantDetailsForGuestUser(this.srpService.applicationData.applicant);
      this.setApplicantDetailsForNonBillLater(this.srpService.applicationData.applicant);
      this.addMenuItem('Location details', me, 0, 'First Step');
      this.addMenuItem('Work request', me, 1, 'Second Step');
      this.addMenuItem('Plumber details', me, 2, 'Third Step');
      this.addMenuItem('Upload site plan', me, 3, 'Fourth Step');
      this.addMenuItem('Applicant details', me, 4, 'Fifth Step');
      this.addMenuItem('Review and submit', me, 5, 'Sixth Step');
      this.addMenuItem('Payment', me, 6, 'Seventh Step');
    }
  }

  updatePaymentTab(showPaymentInfo: boolean): void {
    const me = this;
    this.removeMenuItem('Payment', me);
    if (showPaymentInfo) {
      this.addMenuItem('Payment', me, 6, 'Seventh Step');
    }
  }

  onFeeCodesReceived(): void {
  }

  onWorkRequestOptionChanged(workRequestOption: string): void {
    if(!this.cwwPricingZone && workRequestOption == 'waterConsentOnlyrequired') {
      this.updatePaymentTab(false); // if ww zone and 'Water plugging and/or re-tapping' option is selected, hide the payment tab
    } else {
      this.updatePaymentTab(true);
    }
  }

  getTotalOrderAmount(): number {
    return this.workrequestComponent.totalOrderAmount;
  }

  get controlLabel(): string {
    return 'Upload site plan';
  }

  get floorPlanControlLabel(): string {
    return 'Upload floor plan';
  }

  get commitDisabled(): boolean {
    return (
      (
        this.isRecycledSelected &&
        (!this.srpService.agreedToTsAndCs1 ||
          !this.srpService.agreedToTsAndCs2)) ||
      !this.srpService.agreedToTsAndCs ||
      this.applicant.invalid ||
      this.location.invalid ||
      this.workrequestComponent.invalid ||
      this.plumberDetailsComponent.invalid ||
      this.refNumControl.invalid
    );
  }

  get isDrinkingWaterMandatory(): boolean {
    return this.workrequestComponent.isDrinkingWaterMandatory;
  }

  get isBelowGroundPlumbingMandatory(): boolean {
    return this.workrequestComponent.isBelowGroundPlumbingMandatory;
  }

  get isRecycledWaterMandatory(): boolean {
    return this.workrequestComponent.isRecycledWaterMandatory;
  }

  get plumberDetails(): PlumberDetails {
    return (<Srp>this.srpService.applicationData).plumberDetails;
  }

  get isRecycledSelected(): boolean {
    return this.workrequestComponent.isRecycledSelected;
  }

  get isBelowGroundPlumbingSelected(): boolean {
    return this.workrequestComponent.isBelowGroundPlumbingSelected;
  }

  get isDrinkingWaterSelected(): boolean {
    return this.workrequestComponent.isDrinkingWaterSelected;
  }

  get workRequestViewModel(): WorkrequestViewmodelBase {
    return this.srpService.workRequestViewModel;
  }

  get uploadfilesViewmodel(): UploadfilesViewmodel {
    return this.srpService.uploadfilesViewmodel;
  }

  get uploadFloorPlanFilesViewModel(): UploadfilesViewmodel {
    return this.srpService.uploadFloorPlanFilesViewModel;
  }

  set agreedToTsAndCs1(v: boolean) {
    this.srpService.agreedToTsAndCs1 = v;
  }

  set agreedToTsAndCs2(v: boolean) {
    this.srpService.agreedToTsAndCs2 = v;
  }

  set planAttachmentConfirmation(v: boolean) {
    this.srpService.planAttachmentConfirmation = v;
  }

  get planAttachmentConfirmation(): boolean {
    return this.srpService.planAttachmentConfirmation;
  }

  set floorplanAttachmentConfirmation(v: boolean) {
    this.srpService.floorplanAttachmentConfirmation = v;
  }

  get floorplanAttachmentConfirmation(): boolean {
    return this.srpService.floorplanAttachmentConfirmation;
  }

  canGoNext(executeYes: any, executeNo: any): void {
    this.srpService.submitErrorMessage = '';

    this.termsOfUseUrl = this.cwwPricingZone ? environment.termsOfUseURL.CWW : environment.termsOfUseURL.WW;

    if (this.activeIndex === 0) {
      this.navigateFromLocation(executeYes, executeNo);
    } else if (this.activeIndex === 1) {
      this.workrequestComponent.errorMessage = null;
      if (this.workrequestComponent.invalid && this.workrequestComponent.displayErrorMessage().length > 0) {
        this.workrequestComponent.displayErrorMessage();
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 2) {
      this.plumberDetailsComponent.errorMessage = null;
      if (this.plumberDetailsComponent.invalid && this.plumberDetailsComponent.displayErrorMessage().length > 0) {
        this.plumberDetailsComponent.displayErrorMessage();
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 3) {
      if (!this.uploadFileComponent.isValid || !this.uploadFloorPlanFileComponent.isValid_secondInstance) {
        executeNo();
      } else if (!this.planAttachmentConfirmation || !this.floorplanAttachmentConfirmation) {
        if (!this.planAttachmentConfirmation) {
          this.srpService.submitErrorMessage += 'Please confirm final plots attachment.';
        }

        if (!this.floorplanAttachmentConfirmation) {
          this.srpService.submitErrorMessage += 'Please confirm floor plan attachment.';
        }

        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 4) {
      if (this.applicant.invalid && this.applicant.displayErrorMessage().length > 0) {
        this.srpService.submitErrorMessage += this.applicant.displayErrorMessage();
        executeNo();
        return;
      }
      if (this.isRecycledSelected && this.isRecycledWaterZone && !this.srpService.agreedToTsAndCs2) {
        this.srpService.submitErrorMessage += 'Please select terms and conditions.' + '<br>';
        executeNo();
        return;
      }
      if (this.refNumControl.hasError('maxlength')) {
        this.srpService.submitErrorMessage += 'Customer order/reference number cannot exceed ' + this.refNumControlLength + ' characters';
        executeNo();
        return;
      }
      if (this.refNumControl.hasError('pattern')) {
        this.srpService.submitErrorMessage += 'Please enter valid Customer order/reference number; ' +
          'Alphanumeric characters along with - / : . are allowed e.g. 123-abc, 123/abc, 123:ABC, 123.ABC';
        executeNo();
        return;
      }

      this.validTermsAndConditions(executeNo, executeYes);
      // } else if (this.isGuestUserLoggedIn && this.activeIndex === 5) {
    } else if (!this.loginService.isUserBillLater() && this.activeIndex === 5) {
      // this.navigateToPaymentWhenGuestUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
    } else {
      executeYes();
    }
  }

  goNext(): void {
    // if ((!this.isGuestUserLoggedIn && this.activeIndex === 5) || (this.isGuestUserLoggedIn && this.activeIndex === 6)) {
    if ((this.loginService.isUserBillLater() && this.activeIndex === 5) || (!this.loginService.isUserBillLater() && this.activeIndex === 6)) {
      return;
    }

    this.canGoNext(() => {
      this.activeIndex++;
    }, () => {
    });
  }

  canGoPrevious(): boolean {
    // if (this.isGuestUserLoggedIn && (this.activeIndex === 6 || this.activeIndex === 0)) {
    if (!this.loginService.isUserBillLater() && (this.activeIndex === 6 || this.activeIndex === 0)) {
      return false;
    }

    // if (!this.isGuestUserLoggedIn && this.activeIndex === 0) {
    if (this.loginService.isUserBillLater() && this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.activeIndex--;
  }

  get srp(): ApplicationBase {
    return this.srpService.applicationData;
  }

  submitApplication(callback): void {
    let validData = true;
    const track_invalid_data = [];
    this.srpService.submitErrorMessage = '';

    if (this.location.invalid) {
      this.srpService.submitErrorMessage += this.location.displayErrorMessage();
      track_invalid_data.push({ type: 'location', err: this.srpService.submitErrorMessage });
      validData = false;
    }

    this.workrequestComponent.errorMessage = null;
    if (this.workrequestComponent.invalid && this.workrequestComponent.displayErrorMessage().length > 0) {
      this.srpService.submitErrorMessage += this.workrequestComponent.displayErrorMessage();
      track_invalid_data.push({ type: 'workRequestComponent', err: this.srpService.submitErrorMessage });
      validData = false;
    }

    this.plumberDetailsComponent.errorMessage = null;
    if (this.plumberDetailsComponent.invalid) {
      this.srpService.submitErrorMessage += this.plumberDetailsComponent.displayErrorMessage();
      track_invalid_data.push({ type: 'plumberDetailsComponent', err: this.srpService.submitErrorMessage });
      validData = false;
    }

    if (!this.uploadFileComponent.isValid) {
      this.srpService.submitErrorMessage += this.uploadFileComponent.submitErrorMessage;
      track_invalid_data.push({ type: 'uploadFileComponent', err: this.srpService.submitErrorMessage });
      validData = false;
    }

    if (!this.planAttachmentConfirmation) {
      this.srpService.submitErrorMessage += 'Please confirm final plots attachment.';
      track_invalid_data.push({ type: 'planAttachemtConfirmation', err: this.srpService.submitErrorMessage });
      validData = false;
    }

    if (!this.uploadFloorPlanFileComponent.isValid_secondInstance) {
      this.srpService.submitErrorMessage += this.uploadFloorPlanFileComponent.submitErrorMessage;
      track_invalid_data.push({ type: 'uploadFloorPlanFileComponent', err: this.srpService.submitErrorMessage });
      validData = false;
    }

    if (!this.floorplanAttachmentConfirmation) {
      this.srpService.submitErrorMessage += 'Please confirm floor plan attachment.';
      track_invalid_data.push({ type: 'floorplanAttachmentConfirmation', err: this.srpService.submitErrorMessage });
      validData = false;
    }

    if (this.applicant.invalid) {
      this.srpService.submitErrorMessage += this.applicant.displayErrorMessage();
      track_invalid_data.push({ type: 'applicantInvalid', err: this.srpService.submitErrorMessage });
      validData = false;
    }

    if (this.isRecycledSelected && this.isRecycledWaterZone && !this.srpService.agreedToTsAndCs2) {
      this.srpService.submitErrorMessage += 'Please select terms and conditions.' + '<br>';
      track_invalid_data.push({ type: 'terms and conditions 1', err: this.srpService.submitErrorMessage });
      validData = false;
    }

    if (!this.srpService.agreedToTsAndCs) {
      this.srpService.submitErrorMessage += 'Please select terms and conditions.';
      track_invalid_data.push({ type: 'terms and conditions 2', err: this.srpService.submitErrorMessage });
      validData = false;
    }

    if (!validData) {
      return;
    }

    this.setApplicantData();
    this.srpService.applicationData.toUpperCase();
    this.srpService.applicationData.plumberDetails = this.plumberDetailsComponent.plumberDetails;
    this.srpService.applicationData.workrequestDetails = this.workrequestComponent.workRequestViewModel.workrequestDetails;
    this.srpService.applicationData.workrequestDetails.appendWorkRequestDescription(
      this.workrequestComponent.workRequestViewModel.detailedDescription);
    this.srpService.applicationData.workrequestDetails.appendCombinedDrainDescription();
    this.srpService.applicationData.workrequestDetails.appendPlotsAttachmentConfirmationDescription();
    this.srpService.applicationData.workrequestDetails.isRecycledSelected = this.isRecycledWaterZone && this.isRecycledSelected;
    this.srpService.applicationData.workrequestDetails.propertyOnCombinedDrain = this.workrequestComponent.workRequestViewModel.workrequestDetails.propertyOnCombinedDrain ? this.workrequestComponent.workRequestViewModel.workrequestDetails.propertyOnCombinedDrain : 'Unknown';
    this.srpService.applicationData.locationAddress = this.location.addressDetails.locationAddress;
    this.doSubmit(callback);
  }

  newApplication(): void {
    window.location.reload();
    //super.newApplication();
    //this.uploadFileComponent.clearFiles();
    //this.workrequestComponent.markValidationControlsAsUntouched();
    //this.plumberDetailsComponent.markValidationControlsAsUntouched();
  }

  get shouldDisplayLocation(): boolean {
    return this.activeIndex === 0;
  }

  get shouldDisplayWorkRequest(): boolean {
    return this.activeIndex === 1;
  }

  get shouldDisplayPlumberDetails(): boolean {
    return this.activeIndex === 2;
  }

  get shouldDisplayUploadFiles(): boolean {
    return this.activeIndex === 3;
  }

  get shouldDisplayApplicant(): boolean {
    return this.activeIndex === 4;
  }

  get shouldDisplayPaymentForm(): boolean {
    // return this.isGuestUserLoggedIn && this.activeIndex === 6;
    return !this.loginService.isUserBillLater() && this.activeIndex === 6;
  }

  get shouldDisplayNextButton(): boolean {
    // return (!this.isGuestUserLoggedIn && this.activeIndex !== 5) || (this.isGuestUserLoggedIn && (this.activeIndex !== 5 && this.activeIndex !== 6));
    return (this.loginService.isUserBillLater() && this.activeIndex !== 5) ||
      (!this.loginService.isUserBillLater() && (this.activeIndex !== 5 && this.activeIndex !== 6));
  }

  get shouldDisplayRecycledWaterTCs(): boolean {
    return this.isRecycledSelected && this.isRecycledWaterZone;
  }

  get shouldShowReviewAndSubmit(): boolean {
    return this.activeIndex === 5;
  }

  get shouldShowPaymentInfo(): boolean {
    //return !this.isUserBillLater && this.cwwPricingZone;
    return !this.isUserBillLater;
  }

  get drainerNameLabel(): string {
    return 'Drainer';
  }

  private doSubmit(callback): void {
    this.executeSubmit('srp', callback, this.workrequestComponent.totalOrderAmount, this.uploadFileComponent, true, null, null, this.uploadFloorPlanFileComponent);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/srp-form/srp/srp.component.ts